import styled from 'styled-components';

import MessageCard from '@common/components/MessageCard';

export const Message = styled(MessageCard)`
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'scale', 3)};
  margin-bottom: 0;
`;
